import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { lazy } from "react";
import { Routes, Route } from "react-router-dom";
var MeasureDetail = /*#__PURE__*/lazy(function () {
  return import("pages/measuredetail");
});
var ExcelExport = /*#__PURE__*/lazy(function () {
  return import("pages/excelexport/ExcelExport");
});
var Finder = /*#__PURE__*/lazy(function () {
  return import("pages/finder/Finder");
});
var UnitLists = /*#__PURE__*/lazy(function () {
  return import("pages/unitlists/UnitLists");
});
var EditUnitList = /*#__PURE__*/lazy(function () {
  return import("pages/unitlists/EditUnitList");
});
var Playground = /*#__PURE__*/lazy(function () {
  return import("pages/playground/Playground");
});
var Icons = /*#__PURE__*/lazy(function () {
  return import("pages/icons/Icons");
});
var CompositionsList = /*#__PURE__*/lazy(function () {
  return import("pages/compositions-list/CompositionsList");
});
var Composition = /*#__PURE__*/lazy(function () {
  return import("pages/composition");
});
import { InternalServerError } from "pages/errors";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MeasureDetailRoutes = function MeasureDetailRoutes(props) {
  return /*#__PURE__*/_jsx(Routes, {
    children: /*#__PURE__*/_jsx(Route, {
      path: ":id",
      element: /*#__PURE__*/_jsx(MeasureDetail, _objectSpread({}, props), location.pathname.split("/").pop())
    }, location.pathname.split("/").pop())
  }, location.pathname.split("/").pop());
};
var EditUnitListsRoutes = function EditUnitListsRoutes(props) {
  return /*#__PURE__*/_jsx(Routes, {
    children: /*#__PURE__*/_jsx(Route, {
      path: ":id",
      element: /*#__PURE__*/_jsx(EditUnitList, _objectSpread({}, props))
    })
  });
};
var CompositionListRoutes = function CompositionListRoutes(props) {
  return /*#__PURE__*/_jsx(Routes, {
    children: /*#__PURE__*/_jsx(Route, {
      path: ":category",
      element: /*#__PURE__*/_jsx(CompositionsList, _objectSpread({}, props))
    })
  });
};
var CompositionRoutes = function CompositionRoutes(props) {
  return /*#__PURE__*/_jsx(Routes, {
    children: /*#__PURE__*/_jsx(Route, {
      path: ":id",
      element: /*#__PURE__*/_jsx(Composition, _objectSpread({}, props))
    })
  });
};
export default function genericRoutes(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/indikator/*",
      element: /*#__PURE__*/_jsx(MeasureDetailRoutes, _objectSpread({}, props), location.pathname.split("/").pop())
    }), /*#__PURE__*/_jsx(Route, {
      path: "/dataexport",
      element: /*#__PURE__*/_jsx(ExcelExport, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/finder",
      element: /*#__PURE__*/_jsx(Finder, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/mina-enhetslistor",
      element: /*#__PURE__*/_jsx(UnitLists, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/mina-enhetslistor/*",
      element: /*#__PURE__*/_jsx(EditUnitListsRoutes, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/internt-serverfel",
      element: /*#__PURE__*/_jsx(InternalServerError, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/rapporter",
      element: /*#__PURE__*/_jsx(CompositionsList, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/rapporter/*",
      element: /*#__PURE__*/_jsx(CompositionListRoutes, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/nyheter",
      element: /*#__PURE__*/_jsx(CompositionsList, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/nyheter/*",
      element: /*#__PURE__*/_jsx(CompositionListRoutes, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/nyhet/*",
      element: /*#__PURE__*/_jsx(CompositionRoutes, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/rapport/*",
      element: /*#__PURE__*/_jsx(CompositionRoutes, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/lekstuga/*",
      element: /*#__PURE__*/_jsx(Playground, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/icon-bibliotek/*",
      element: /*#__PURE__*/_jsx(Icons, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/",
      element: /*#__PURE__*/_jsx(Composition, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/*",
      element: /*#__PURE__*/_jsx(CompositionRoutes, _objectSpread({}, props))
    })]
  });
}